import axios from "../../services/axios";

interface GetAllParams {
  query : any;
}

const BookingService = {
  getAll: async ({query}: GetAllParams) => {
    try {
      const res = await axios.get(`/bookings?${query}`);

      return {
        data: res.data.data,
        pagination: res.data.meta.pagination,
      };
    } catch (error) {
      console.error("Error fetching bookings:", error);
      throw error;
    }
  },

  getById: async (bookingId: string | null| undefined) => {
    try {
      const res = await axios.get(`/bookings/${bookingId}`, {
        params: {
          populate: "*",
        },
      });

      return res.data.data; // Assuming the event details are in `data`
    } catch (error) {
      console.error(`Error fetching booking with ID ${bookingId}:`, error);
      throw error;
    }
  },


  create: async (booking: any) => {
    try {
      const response = await axios.post(
        `/bookings`, booking
      );
      return response.data;
    } catch (error) {
      console.error("Error creating booking:", error);
      throw error;
    }
  },

  update: async (bookingId: string, booking: any) => {
    try {
      const response = await axios.put(`/bookings/${bookingId}`, booking);
      return response.data;
    } catch (error) {
      console.error(`Error updating event with ID ${bookingId}:`, error);
      throw error;
    }
  },

  getPricing: async (numberOfPlayers: number, durationMinutes: number, exhibitorId: string | undefined) => {
    try {
      const res = await axios.get(
        `/pricing/booking`,
        {
          params: {
            numberOfPlayers,
            durationMinutes,
            exhibitorId,
          },
        }
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching pricing:", error);
      throw error;
    }
  },
  delete: async (selected: string[]) => {
    try {
      const response = await axios.delete(`/bookings/${selected}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting currency:", error);
      throw error;
    }
  },
};

export default BookingService;
